<template>
  <div class="status-echart">
    <div class="status-content">
      <Header
        :middleText="$t('integration.monitoring_point_status')"
        :rightIcon="pointStatusConfig.rightIcon"
      />
      <template v-if="statusChart.pieSeries.length">
        <pieEchart :chartData="statusChart" />
      </template>
      <div v-else class="empty" style="margin-top: 70px;">
        {{
          $t('integration.there_are_currently_no_monitoring_points_available')
        }}
      </div>
    </div>
    <div class="status-content">
      <Header
        class="header-echart"
        :middleText="$t('integration.monitoring_point_type')"
        :rightIcon="pointTypeConfig.rightIcon"
      />
      <template v-if="typeChart.pieSeries.length">
        <pieEchart :chartData="typeChart" />
      </template>
      <div v-else class="empty" style="margin-top: 70px;">
        {{
          $t('integration.there_are_currently_no_monitoring_points_available')
        }}
      </div>
    </div>
  </div>
</template>

<script>
import Header from '../../Header.vue'
import { pointStatusConfig, pointTypeConfig } from './config/analConfig'
import pieEchart from '@/components/echart/pieEchart.vue'
import { analPointStatus, analPointType } from '@/api/modules/monitorPoint'
import { carrierStatusConvert } from '@/utils/convert'
import { getLanguage } from '@/lang'

import bus from '@/utils/bus'

export default {
  props: ['deviceStatus', 'deviceType'],
  watch: {},
  components: {
    Header,
    pieEchart
  },
  data () {
    return {
      pointStatusConfig,
      pointTypeConfig,
      // 已选中的数据 数组形式
      checkedData: [],
      // 监测点状态chart
      statusChart: {
        pieSeries: [],
        rest: {
          title: $t('integration.monitoring_point_status'),
          name: $t('integration.monitoring_point_status'),
          isTip: true,
          labelLine: {
            show: true
          },
          label: {
            show: true
          },
          legend: {
            show: false
          }
        }
      },
      // 监测点类型chart
      typeChart: {
        pieSeries: [],
        rest: {
          title: $t('integration.monitoring_point_type'),
          name: $t('integration.monitoring_point_type'),
          isTip: true,
          labelLine: {
            show: true
          },
          label: {
            show: true
          },
          legend: {
            show: false
          }
        }
      }
    }
  },
  methods: {
    getPointStatus () {
      analPointStatus(this.checkedData).then(({ result }) => {
        const series = result.map(item => {
          item.name = this.$t(carrierStatusConvert(item.name).title)
          return item
        })
        this.$set(this.statusChart, 'pieSeries', series)
      })
    },
    getPointType () {
      analPointType(this.checkedData).then(({ result }) => {
        console.log('pie === >', result)
        // this.$set(this.typeChart, 'pieSeries', result)
        this.$set(this.typeChart, 'pieSeries', result.map((item,index) => {
          return {
            value: item.value,
            // name: item.name
            name: getLanguage() === 'zh_CN'? item.name: item.code
          }
        }))
      })
    }
  },
  mounted () {
    this.getPointStatus()
    this.getPointType()
    // bus.$on('saveMonitorPoint', (rows) => {
    //   // 接收到数据
    //   this.checkedData=rows.map(item=>item.id);
    //   this.getPointStatus();
    //   this.getPointType();
    // });

    // bus.$on('reflashData', rows => {
    //     this.getPointStatus();
    //     this.getPointType();
    // });
  },
  beforeDestroy () {
    bus.$off('saveMonitorPoint')
    bus.$off('reflashData')
  }
}
</script>

<style lang="scss" scoped>
.status-echart {
  border: 1px solid #ccc;
  width: 400px;
  display: inline-block;
  height: 100%;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  overflow: auto;

  .status-content {
    // flex: 1;
    height: 400px;
  }

  .header-echart {
    border-top: 1px solid #cccccc;
  }

  .echarts {
    width: 100%;
    height: 360px !important;
  }
}
</style>
